import { FormLayout } from "@qpd-reestr/layout";
import { useServices, useStore } from "../../../hooks";
import { PropsWithChildren, useCallback, useEffect, useRef, useState } from "react";
import { showErrorNotification } from "../../../utils";

/**
 * Декоратор синхронизации времени
 */
const TimeSyncDecorator: React.FC<PropsWithChildren> = (props) => {

    const { userStore } = useStore();
    const services = useServices();

    // признак сверки данных времени клиента и сервера
    const [timeWasChecked, setTimeWasChecked] = useState<boolean>(false);

    // Флаг, активна ли владка с приложением
    const [isWindowActive, setIsWindowActive] = useState(true);

    const timeChecker = useRef<NodeJS.Timeout | undefined>(undefined);

    // Запрос на разрешение проверять время с серверным
    const toggleCheckTimeInterval = useCallback(async () => {
        if (isWindowActive) {
            try {
                const result = await services.timeSyncService.getIsAllowCheckTime();
                if (result.isTimeSyncEnabled && result.checkTimeInterval) {
                    checkTime();
                    timeChecker.current = setInterval(checkTime, result.checkTimeInterval * 1000);
                }
            } catch (error: any) {
                showErrorNotification(error);
            }
        }
        else {
            clearInterval(timeChecker.current);
            timeChecker.current = undefined;
            setTimeWasChecked(false);
        }
    }, [isWindowActive]);

    useEffect(() => {
        toggleCheckTimeInterval();
        return () => {
            clearInterval(timeChecker.current);
            setTimeWasChecked(false);
        };
    }, [toggleCheckTimeInterval]);

    // Запрос на проверку времени с серверным (после того, как сработал запрос на разрешение сверять время)
    const checkTime = useCallback(async () => {
        if (isWindowActive) {
            try {
                await services.timeSyncService.getServerTime({ ClientTimeUTC: new Date(Date.now()).toISOString() });
                userStore.isTimeDesynchronization = false;
            } catch (error: any) {
                userStore.isTimeDesynchronization = true;
            } finally {
                setTimeWasChecked(true);
            }
        }
    }, [isWindowActive]);

    // Слушатель, который остеживает активность пользователя (если ушел с вкладки, то isWindowActive = false)
    useEffect(() => {
        const handlerUserActivity = () => {
            setIsWindowActive(document.visibilityState === 'visible');
        };

        document.addEventListener('visibilitychange', handlerUserActivity);
        return () => document.removeEventListener('visibilitychange', handlerUserActivity);
    }, []);

    // ждем окончания загрузки
    if (timeChecker.current && !timeWasChecked) return <FormLayout registrarKey={process.env.REACT_APP_REGISTRAR_KEY ?? ""}></FormLayout>;

    return <>{props.children}</>
}

export default TimeSyncDecorator;